/**
*
* Solutions / SMME
*
*/

import React, { Fragment } from 'react';
import { Row, Col, Icon } from 'antd';
import { Link } from 'react-router-dom';
import { LandingContainer, SubTitle } from '../../../../components';
import endPoints from '../../../../config/endPoints';
import { constants } from '../../../../devUtils';

const Corporate = () => (
  <Fragment>
    <section className="section-solution">
      <Row align="middle" type="flex" justify="start">
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <img
            src={endPoints.BUILT_EVERYONE_CORPORATE.URL}
            alt={endPoints.BUILT_EVERYONE_CORPORATE.ALT}
            className="width-100 img-grayscale"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="padding-l-4">
          <h2 className="font-18"><b>Corporates</b></h2>
          <p>
            We provide a flexible and practical approach to forward-thinking enterprises with powerful<br />
            yet easy-to-use technology platform, that are designed to help your team work better together.
          </p>
          <Row align="middle" type="flex" justify="start" className="padding-1">
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <img
                src={endPoints.BUILT_EVERYONE_TEAM_ICON.URL}
                alt={endPoints.BUILT_EVERYONE_TEAM_ICON.ALT}
                className="width-8 icon"
              />
            </Col>
            <Col xs={24} sm={24} md={21} lg={21} xl={21}>
              <p className="nomargin">
                Flexibility to customise your support solution with tools like advanced<br />
                workflow capabilities and AI-powered automation.
              </p>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-1"></Col>
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <img
                src={endPoints.BUILT_EVERYONE_CARD_ICON.URL}
                alt={endPoints.BUILT_EVERYONE_CARD_ICON.ALT}
                className="width-8 icon"
              />
            </Col>
            <Col xs={24} sm={24} md={21} lg={21} xl={21}>
              <p className="nomargin">
                Modular design, configurable to your unique needs and seamlessly integrable<br />
                with top accounting software.
              </p>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-1"></Col>
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <img
                src={endPoints.BUILT_EVERYONE_FLOW_ICON.URL}
                alt={endPoints.BUILT_EVERYONE_FLOW_ICON.ALT}
                className="width-8 icon"
              />
            </Col>
            <Col xs={24} sm={24} md={21} lg={21} xl={21}>
              <p className="nomargin">
                Improve workplace motivation and boost team performance.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
    <section className="padding-tb-3">
      <LandingContainer>
        <div className="text-center padding-tb-2">
          <SubTitle fontWeight="900" className="font-26">Focus on brand growth with one-time expense<br />
            and rewards management from Zaggle
          </SubTitle>
        </div>
        <Row align="middle" type="flex" gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h2>Personalize the employee expectations</h2>
            <p>
              Employee gifting is a crucial part of corporate culture annually. To choose the best gifts for the employee becomes an extra responsibility of the organization, at this point, Zaggle Edge comes with a variety of gift cards for the employees.
              <br /> <br />
              The exclusive Zaggle Edge gift cards can solve the problem of the corporates and gives the employee the freedom to choose their gifts from the preferred brands.
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img
              src={endPoints.COPORATE_PERSONALIZE.URL}
              alt={endPoints.COPORATE_PERSONALIZE.ALT}
              className="width-100 img-grayscale"
            />
          </Col>
        </Row>
      </LandingContainer>
    </section>
    <section className="padding-tb-3">
      <LandingContainer>
        <Row align="middle" type="flex" gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img
              src={endPoints.COPORATE_SCALE.URL}
              alt={endPoints.COPORATE_SCALE.ALT}
              className="width-100 img-grayscale"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h2>Scale up your workflow</h2>
            <p>
              Zaggle propel is an easy-to-use system to manage all the rewards programs from one integrated platform to increase productivity, increase profitability, and reduce attrition.
              <br /> <br />
              The corporates with their large employee network can make use of zaggle propel to scale up their workflow and automate the reward management.
            </p>
          </Col>
        </Row>
      </LandingContainer>
    </section>
    <section className="padding-tb-3">
      <LandingContainer>
        <Row align="middle" type="flex" gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h2>Get on the same page</h2>
            <p>
              Zaggle is supporting the businesses to manage employee benefits and tax management in one place.
              <br /><br />
              It helps in giving total control over the expenditures and helps in staying on the same page without discrepancies.
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img
              src={endPoints.COPORATE_GET.URL}
              alt={endPoints.COPORATE_GET.ALT}
              className="width-100 img-grayscale"
            />
          </Col>
        </Row>
      </LandingContainer>
    </section>
    <section className="gray-greadient text-center padding-tb-5">
      <LandingContainer>
        <SubTitle fontWeight="900" className="font-26">
          See how Zaggle products can fit your needs
        </SubTitle>
        <Link to={constants.LINK_CONTACTUS} className="btn red-btn">CONNECT WITH EXPERT NOW<Icon type="right" /></Link>
      </LandingContainer>
    </section>
  </Fragment>
);

export default Corporate;



// WEBPACK FOOTER //
// client/containers/NewLanding/Solutions/Corporate/index.js